module.exports = __webpack_public_path__ + "img/indiamart.cdbcb53d.png";